const reduxStore = {
    App: require('./app/appRedux').reducer,
    SagaAuth: require('./sagaAuth/sagaAuthRedux').reducer,
    Volatile: require('./volatile/volatileRedux').reducer,
    Language: require('./languageSwitcher/languageSwitcherRedux').reducer,
    SagaProject: require('./sagaProject/sagaProjectRedux').reducer,
    SagaProperty: require('./sagaProperty/sagaPropertyRedux').reducer,
    SagaOffer: require('./sagaOffer/sagaOfferRedux').reducer,
    SagaContract: require('./sagaContract/sagaContractRedux').reducer,
    SagaUser: require('./sagaUser/sagaUserRedux').reducer,
    SagaEnquiry: require('./sagaEnquiry/sagaEnquiryRedux').reducer,
    SagaSetting: require('./sagaSetting/sagaSettingRedux').reducer,
    SagaReport: require('./sagaReport/sagaReportRedux').reducer,
    SagaDeed: require('./sagaDeed/sagaDeedRedux').reducer,
    SagaLoan: require('./sagaLoan/sagaLoanRedux').reducer,
    SagaContact: require('./sagaContact/sagaContactRedux').reducer,
    SagaLead: require('./sagaLead/sagaLeadRedux').reducer,
    SagaEmail: require('./sagaEmail/sagaEmailRedux').reducer,
};

export default reduxStore;


// WEBPACK FOOTER //
// ./src/redux/reducers.ts